// extracted by mini-css-extract-plugin
export var tosLink = "_ad-0";